import * as R from 'remeda'
import { useMemo } from 'react'
import { EventsMap, RoomEventsMap } from './types'
import { useAssembledBlocksAndMarkers } from './useAssembledBlocksAndMarkers'

interface Params {
  botId?: string
  events: RoomEventsMap
  guestId?: string
  initialEvents?: EventsMap
  roomId: string
}

const isInitial = (events: EventsMap | undefined, initialEvents: EventsMap | undefined) => {
  const numberOfEventsWithoutSystemMessages = R.pipe(
    events ?? {},
    R.omitBy(event => event?.type === 'SystemMessage'),
    R.keys(),
    R.length()
  )
  return Boolean(initialEvents && numberOfEventsWithoutSystemMessages <= 2)
}
const addInitialEvents = (events: EventsMap | undefined, initialEvents: EventsMap | undefined) => {
  if (isInitial(events, initialEvents)) {
    return initialEvents
  }
  return events
}

export const useRoomDataAndEffects = ({
  roomId,
  events,
  guestId,
  botId,
  initialEvents,
}: Params) => {
  const roomEvents = useMemo(
    () => addInitialEvents(events[roomId], initialEvents),
    [events, initialEvents, roomId]
  )

  const roomEventsArray = useAssembledBlocksAndMarkers(roomEvents, guestId, botId)

  const value = useMemo(() => {
    return {
      events: R.sortBy(roomEventsArray, event => event.timestamp),
      isInitial: isInitial(events[roomId], initialEvents),
    }
  }, [roomEventsArray, events, roomId, initialEvents])

  return value
}
